import { render, staticRenderFns } from "./hina-switch.vue?vue&type=template&id=2aae52db&scoped=true"
import script from "./hina-switch.vue?vue&type=script&lang=ts"
export * from "./hina-switch.vue?vue&type=script&lang=ts"
import style0 from "./hina-switch.vue?vue&type=style&index=0&id=2aae52db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aae52db",
  null
  
)

export default component.exports